import { Outlet } from 'react-router-dom';

export type ActivosModuleProps = {};

const ActivosModule: React.FC<ActivosModuleProps> = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
export default ActivosModule;
